export const HEIGHT_OFFSET = 76;
export const SCROLL_TOP_OFFSET = 34;
export const PAYER_VERIFICATION_OTP_EVENT =
  'tier_one_support_payer_verification';
export const SEND_TO_SMS = 'sms';
export const SEND_TO_EMAIL = 'email';
export const OTP_CANNOT_SEND = 4175;
export const DIALOG_STEP = {
  CONFIGURE: 'configure',
  DELIVERY: 'delivery',
};
